export default __webpack_public_path__ + "static/media/tuto-step-5.28280b6c.gif";